'use client';
import apartmentFilters from '@/app/dashboard/apartments/filters';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  CustomErrandFieldTypeConfig,
  type CustomErrandFieldType,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const CustomErrandFieldTypeItem: RelationFieldProps<CustomErrandFieldType> =
  {
    nested: getRelationFieldNames(CustomErrandFieldTypeConfig),
    filters: apartmentFilters,
    renderItem: (item, isRelationField) => ({
      title: item.title,
      descriptionItems: (
        <div
          className={cn(
            isRelationField ? 'grid w-full' : 'flex flex-wrap items-center'
          )}
        >
          <div className='font-medium'>
            {item.description ?? 'Ingen beskrivning angiven'}
          </div>
          {!isRelationField && <Dot />}
          <div
            className={cn(
              'flex items-center',
              isRelationField && 'w-full justify-between'
            )}
          >
            <span>
              {CustomErrandFieldTypeConfig.fields.kind.choices?.find(
                (c) => c.v === item?.kind
              )?.d ?? '-'}
            </span>
            {!isRelationField && <Dot />}
            <span> {item.customId ?? 'Inget objekts-id angivet'}</span>
          </div>
        </div>
      ),
    }),
  };
